<template>
  <div>
    <loader v-if="loading" />
    <template v-else>
      <div>
        <!-- Info Guide -->
        <info-guide
          v-if="guideVisibleFirstTime"
          type="otherOverheadsExamples"
          visible
          @click="closeInfoFirstTime"
        />
        <!-- /Info Guide -->

        <div class="d-flex justify-content-end margin-guide-not-visible" />
      </div>
    </template>

    <!-- Other Overheads Tabs -->
    <other-overheads-tabs v-if="!loading" class="mb-4" />
    <!-- /Other Overheads Tabs -->

    <!-- Other Overheads List -->
    <other-overheads-list class="mb-4" :disabled="aiTemplateLoader" />
    <!-- /Other Overheads List -->

    <!-- Add More Details -->
    <add-more-details
      v-if="!loading"
      :category="'forecast'"
      :step="'other-overheads'"
      :concept-name="'otherOverheadsMoreDetails'"
      :completed-step-name="'otherOverheadsCompleted'"
    />
    <!-- /Add More Details -->

    <!-- Info Guide Drawer -->
    <info-guide-drawer
      type="otherOverheadsExamples"
      :visible="guideVisible"
      @close="guideVisible = false;"
    />
    <!-- /Info Guide Drawer -->

    <!-- Ai Buddy Drawer -->
    <ai-buddy-drawer
      :visible="aiBuddyDrawerVisible"
      type="other-overheads"
      @close="aiBuddyDrawerVisible = false"
    />
    <!-- /Ai Buddy Drawer -->
  </div>
</template>

<script>

import AddMoreDetails from '@/views/Home/StoryMode/Components/AddMoreDetails.vue'
import AiBuddyDrawer from '@/views/Home/StoryMode/Components/AiBuddy/AiBuddyDrawer.vue'
import EventBus from '@/event-bus'
import InfoGuide from '@/views/Home/StoryMode/Components/Example/InfoGuide.vue'
import InfoGuideDrawer from '@/views/Home/StoryMode/Components/Example/InfoGuideDrawer.vue'
import Loader from '@/components/Loader'
import MixinAiBuddyDrawer from '@/mixins/aiBuddyDrawer'
import MixinAiTemplate from '@/mixins/aiTemplate'
import MixinApiCalculations from '@/mixins/apiCalculations'
import MixinGuide from '@/mixins/guide'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'
import OtherOverheadsList from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/OtherOverheads/OtherOverheadsList.vue'
import OtherOverheadsTabs from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/OtherOverheads/OtherOverheadsTabs.vue'
import addOtherOverheadOptions from '@/views/Home/StoryMode/Forecast/OtherOverheads/Dialogs/addOtherOverheadOptions'

export default {
  name: 'ExpensesOtherOverheads',

  components: {
    AddMoreDetails,
    OtherOverheadsList,
    OtherOverheadsTabs,
    InfoGuide,
    AiBuddyDrawer,
    InfoGuideDrawer,
    Loader
  },

  mixins: [MixinApiCalculations, MixinGuide, MixinIdeaRoles, MixinAiBuddyDrawer, MixinAiTemplate],

  data () {
    return {
      loading: false,
      addOtherOverheadOptions
    }
  },

  mounted () {
    this.openGuide('otherOverheadsFinancialPlanGuide')

    EventBus.$on('loading', (payload) => {
      this.loading = payload
    })

    EventBus.$on('open-info', () => {
      this.guideVisible = true
    })

    EventBus.$on('close-info-first-time', () => {
      this.guideVisibleFirstTime = false
    })
  },

  beforeDestroy () {
    EventBus.$off('loading')
    EventBus.$off('open-info')
    EventBus.$off('close-info-first-time')
  }
}
</script>
